module.exports = __webpack_public_path__ + "distribution/img/x121.e977eed6.png";